import React from 'react';
import { Nav, NavItem, Navbar } from 'react-bootstrap';
import Auth from '../lib/Auth';
import LoggedInUser from '../lib/LoggedInUser';
import { Link } from 'react-router-dom';
const styles = {};
styles.navbar = {
  borderRadius: '0px',
  background: 'black'
};
styles.navbar_brand = {
  color: 'white'
};

class Header extends React.Component {
  render() {
    const self = this;
    return (
      <Navbar style={{ ...styles.navbar }} inverse collapseOnSelect>
        <Navbar.Header>
          <Navbar.Brand>
            <a style={{ color: 'white' }} href="#">
              Swipecast Admin
            </a>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            <NavItem
              eventKey={1}
              href="#"
              onClick={() => self.props.history.push('/waitlist')}
            >
              Waitlist
            </NavItem>
            <NavItem
              eventKey={1}
              href="#"
              onClick={() => self.props.history.push('/users')}
            >
              Users
            </NavItem>
            <NavItem
              eventKey={1}
              href="#"
              onClick={() => self.props.history.push('/jobs')}
            >
              Jobs
            </NavItem>
            <NavItem
              eventKey={1}
              href="#"
              onClick={() => self.props.history.push('/charges')}
            >
              Charges
            </NavItem>
            <NavItem
              eventKey={1}
              href="#"
              onClick={() => self.props.history.push('/conversations')}
            >
              Conversations
            </NavItem>
            <NavItem
              eventKey={1}
              href="#"
              onClick={() => self.props.history.push('/talent')}
            >
              Talent
            </NavItem>
             <NavItem
              eventKey={1}
              href="#"
              onClick={() => self.props.history.push('/active_talent')}
            >
              Talent(28D)
            </NavItem>
            <NavItem
              eventKey={1}
              href="#"
              onClick={() => self.props.history.push('/funnel')}
            >
              Funnel
            </NavItem>
            <NavItem
              eventKey={1}
              href="#"
              onClick={() => self.props.history.push('/active_client')}
            >
            Client(28D)
            </NavItem>
            <NavItem
              eventKey={1}
              href="#"
              onClick={() => self.props.history.push('/disintermediation')}
            >
            Disintermediation
            </NavItem>
            <NavItem
              eventKey={1}
              href="#"
              onClick={() => self.props.history.push('/data_dashboard')}
            >
            OKRs
            </NavItem>
          </Nav>

          <Nav pullRight>
            <NavItem
              eventKey={1}
              href="#"
              onClick={function() {
                Auth.logOut().then(function() {
                  LoggedInUser.setInfo(null);
                  self.props.history.push('/');
                });
              }}
            >
              Sign Out
            </NavItem>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default Header;
